import Cookie from "./cookie";
import ExtraExperiments from "./extraExperiments";
import axios from "axios";

const qs = require('querystring');
const UaParser = require('ua-parser-js');

const envProps = {
  // from backend:
  lang: document.documentElement.lang,
  isRtlLanguage: false,
  cookieDomain: '',
  country: '',
  // from runtime:
  query: qs.parse(location.search.substr(1)),
  hash: qs.parse(location.hash.substr(1)),
  channel: [],
  countryTier: require('../country-tier.json'),
  gaTrackers: {},
};

window.envProps = envProps;

let envPropsNode = document.querySelector('script[data-type="env-props"]');
if (envPropsNode) {
  envPropsNode.parentNode.removeChild(envPropsNode);
  try {
    const _envProps = JSON.parse(envPropsNode.textContent);
    Object.assign(envProps, _envProps);
  } catch (err) {}
}

const uaParser = envProps.uaParser = new UaParser();
envProps.ua = uaParser.getUA();
envProps.browser = uaParser.getBrowser();
envProps.device = uaParser.getDevice();
envProps.os = uaParser.getOS();

envProps.country = envProps.country || Cookie.get("country");
if (!envProps.country) {
    envProps.country = localStorage.getItem('country');
}

updateCountryCode();

envProps.countryTierName = getCountryTierName();

envProps.extraExperiments = new ExtraExperiments(0);

initDeviceType();
initStats();

function getCountryTierName() {
  if (!envProps.country || !envProps.countryTier) {
    return "";
  }

  for (var tierName in envProps.countryTier) {
    if (envProps.countryTier.hasOwnProperty(tierName)) {
      if (envProps.countryTier[tierName].indexOf(envProps.country) > -1) {
        return tierName;
      }
    }
  }

  return "";
}

function initDeviceType() {
  var supportPlatforms = [
    "Android",
    "Bada",
    "BlackBerry",
    "Firefox OS",
    "iOS",
    "MeeGo",
    "Sailfish",
    "Series40",
    "Symbian",
    "Tizen",
    "WebOS",
    "Windows Phone"
  ];

  if (!envProps.device.type && envProps.os.name) {
    if (supportPlatforms.indexOf(envProps.os.name) > -1) {
      envProps.device.type = "mobile";
    }
  }

  if (envProps.device.type) {
    if (envProps.device.type === "tablet") {
      envProps.mobile = true;
      document.documentElement.classList.add("tablet");
    } else if (envProps.device.type === "mobile" || envProps.device.type === "wearable") {
      envProps.mobile = true;
      document.documentElement.classList.add("mobile");
    } else {
      envProps.mobile = false;
    }
  }

  if (envProps.mobile) {
    var browsers = [
      "Android Browser",
      "Chrome",
      "Chrome Mobile",
      "Chrome Mobile iOS",
      "Edge Mobile",
      "IE Mobile",
      "Fennec",
      "Firefox",
      "Firefox Mobile",
      "Opera",
      "Opera Mobile",
      "Opera Mini",
      "Safari",
      "Mobile Safari",
      "UCBrowser",
      "UC Browser",
      "Yandex",
      "Yandex Browser"
    ];

    envProps.browser.inApp = false;
    if (envProps.browser.name && browsers.indexOf(envProps.browser.name) === -1) {
      envProps.browser.inApp = true;
    }
  }
}

function initStats() {
  envProps.stats = {
    uid: "",
    basicMetricsTracking: {},
  };

  envProps.stats.uid = Cookie.get("uid");
  if (!envProps.stats.uid) {
    // generate uid value
    envProps.stats.uid = (function() {
      var chars = "0123456789abcdef".split(""),
        uid = [],
        i;
      for (i = 0; i < 16; i++) {
        uid[i] = chars[0 | (Math.random() * 16)];
      }
      return uid.join("");
    })();
    // set uid cookie
    Cookie.set("uid", envProps.stats.uid, 3650, envProps.cookieDomain);
  }
}

async function updateCountryCode() {
    const lastCheckUpdate = localStorage.getItem('lastCheckUpdate');
    if (envProps.country && lastCheckUpdate && howManyDaysPassed(lastCheckUpdate) <= 3) {
        return;
    }

    const country = await fetchCountryCode();
    if (country) {
        envProps.country = country.toLowerCase();
        localStorage.setItem('country', envProps.country);
        localStorage.setItem('lastCheckUpdate', Date.now());
    }
    dispatchGetGeoEvent(envProps.country || '');
}

function dispatchGetGeoEvent(countryCode) {
    const event = new CustomEvent('getGeo', { detail: { countryCode } });
    document.dispatchEvent(event);
}

function howManyDaysPassed(startTimestamp) {
    return Math.floor((Date.now() - startTimestamp) / (60 * 60 * 24 * 1000));
}

async function fetchCountryCode() {
    try {
        const {data} = await axios.get('/get_country_code');
        return data;
    } catch (err) {
        console.error('fetchCountryCode error: ', err);
    }

    return '';
}

export default envProps;
